module.exports = __webpack_public_path__ + "img/FA6.e7032839.png";